import { Button, Spinner, LoadMoreButton, ButtonDropdown } from "@rio-cloud/rio-uikit";
import FailureForm from "../form/FailureForm";
import { Dialog } from "@rio-cloud/rio-uikit";
import { useFailures } from "../../../../hooks/useFailures";
import { RestrictArea } from "../../../../components/restrictArea";

const FailuresPage = () => {
  const {
    failures,
    loading,
    deleteLoading,
    error,
    showForm,
    editingFailure,
    showDeleteDialog,
    failureToDelete,
    handleEdit,
    handleDelete,
    confirmDelete,
    handleFormClose,
    setShowForm,
    setShowDeleteDialog,
    editFailure,
    addFailure,
    userHasAccess,
    totalElements,
    loadMoreFailures,
  } = useFailures();

  if (loading || userHasAccess === null) {
    return (
      <>
        <div className="flex justify-center items-center h-64">
          <Spinner />
        </div>
      </>
    );
  }

  if (!userHasAccess) {
    return <RestrictArea showBackButton={false} />;
  }

  if (error) {
    return (
      <>
        <div className="flex justify-center items-center h-64">
          <div className="text-red-600 text-center">
            <p className="text-lg font-semibold mb-2">Erro ao carregar literatura técnica</p>
            <p className="text-sm">{error}</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="p-6 max-w-[1000px] mx-auto">
        <div className="flex justify-between items-center mb-6">
          <div>
            <div className="text-size-h2">Literatura técnica</div>
          </div>
          <Button
            bsStyle={Button.PRIMARY}
            onClick={() => setShowForm(true)}
            iconName="rioglyph-plus-sign"
            className="bg-teal-600 hover:bg-teal-700"
          >
            Nova Falha
          </Button>
        </div>

        <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-neutral-700">
              <thead className="bg-gray-50 dark:bg-neutral-900">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 dark:text-neutral-400">
                    Título
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 dark:text-neutral-400">
                    Descrição
                  </th>
                  <th className="px-6 py-3 text-left font-medium text-gray-500 dark:text-neutral-400 w-[120px]">
                    Link do vídeo
                  </th>
                  <th className="px-6 py-3 text-right font-medium text-gray-500 dark:text-neutral-400 w-[100px]"></th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-neutral-800 divide-y divide-gray-200 dark:divide-neutral-700">
                {failures.map((failure) => (
                  <tr key={failure.id} className="hover:bg-gray-50 dark:hover:bg-neutral-700">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="font-medium text-gray-900 dark:text-neutral-100">{failure.title}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-gray-900 dark:text-neutral-100 max-w-xs truncate">{failure.description}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {failure.videoUrl ? (
                        <span
                          onClick={() => {
                            window.open(failure.videoUrl, '_blank');
                          }}
                          className="text-color-primary cursor-pointer"
                        >
                          Ver vídeo
                        </span>
                      ) : (
                        <span className="text-gray-400 dark:text-neutral-500">Sem vídeo</span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end space-x-2">
                        <ButtonDropdown
                          title={<span className='rioglyph rioglyph-option-vertical' />}
                          items={[
                            {
                              value: 'Editar',
                              onSelect: () => handleEdit(failure)
                            },
                            {
                              value: 'Excluir',
                              onSelect: () => handleDelete(failure)
                            }
                          ]}
                          bsStyle='muted'
                          pullRight
                          noCaret
                          usePortal
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {failures.length === 0 && (
            <div className="text-center py-12">
              <div className="text-gray-500 dark:text-neutral-400">
                <p className="font-medium mb-2">
                  Nenhuma falha cadastrada
                </p>
              </div>
            </div>
          )}

        </div>
          {failures.length > 0 && (
            <div className="p-4 border-t border-gray-200 dark:border-neutral-700">
              <LoadMoreButton
                loaded={failures.length}
                total={totalElements}
                onLoadMore={loadMoreFailures}
                loadMoreMessage="Carregar mais falhas"
                noMoreMessage="Todas as falhas foram carregadas"
              />
            </div>
          )}

        {showForm && (
          <Dialog
            show={showForm}
            onClose={handleFormClose}
            showCloseButton={true}
            title={editingFailure ? "Editar Falha" : "Nova Falha"}
            bsSize={Dialog.SIZE_MD}
            body={(
              <FailureForm
                failure={editingFailure}
                onSave={(title, description, videoFile) => {
                  if (editingFailure) {
                    return editFailure(editingFailure.id!, title, description, videoFile);
                  } else if (videoFile) {
                    return addFailure(title, description, videoFile);
                  }
                  return Promise.resolve(false);
                }}
                onCancel={handleFormClose}
              />
            )}
          />
        )}

        <Dialog
          show={showDeleteDialog}
          onClose={() => setShowDeleteDialog(false)}
          title="Confirmar Exclusão"
          bsSize={Dialog.SIZE_SM}
        >
          <div className="p-6">
            <p className="text-size-h4 text-gray-700 dark:text-neutral-300 mb-4">
              Tem certeza?
            </p>
            <p className="text-gray-600 dark:text-neutral-400">
              Você está prestes a excluir a falha <strong>{failureToDelete?.title}</strong>.
            </p>
            <p className="text-gray-600 dark:text-neutral-400 mb-6">
              Esta ação não pode ser desfeita.
            </p>
            <div className="flex justify-end space-x-3">
              <Button
                bsStyle={Button.DEFAULT}
                onClick={() => setShowDeleteDialog(false)}
              >
                Cancelar
              </Button>
              <Button
                bsStyle={Button.DANGER}
                onClick={confirmDelete}
                disabled={deleteLoading}
                iconName={deleteLoading ? "rioglyph-spinner" : undefined}
              >
                {deleteLoading ? "Excluindo..." : "Excluir"}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default FailuresPage;
